import styles from "./CreateAccountBillingStyle.module.scss";
import { CircularProgress, Grid2 } from "@mui/material";
import CustomInput from "../../../../GlobalComponents/CustomInput/CustomInput";
// import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
// import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Dropdown from "../../../../GlobalComponents/Dropdown/Dropdown";
import { ReactComponent as Usa } from "../../../../GlobalAssets/svg/UsaSvg.svg";
import { ReactComponent as Indian } from "../../../../GlobalAssets/svg/IndianSvg.svg";

export default function CreateAccountBilling({
  formFieldUpdate,
  isBilling,
  billingForm,
  errors,
  errorMessages,
  updated,
  isAddress,
  isFullOrgAddress,
}) {
  // const [isChecked, setIsChecked] = useState(false);
  const countryOptions = [
    { label: "INDIA", value: "India", img: <Indian /> },
    { label: "USA", value: "USA", img: <Usa /> },
  ];

  return (
    <Grid2 className={styles.mainContainer}>
      <Grid2 className={styles.label20}>Billing Address</Grid2>

      {isBilling &&
        (isAddress ? (
          <Grid2 className={styles.loading}>
            <CircularProgress />
          </Grid2>
        ) : (
          <Grid2 className={styles.billing}>
            <hr className={styles.line} />
            <Grid2 className={styles.inputContainer}>
              <Dropdown
                title="Country"
                options={countryOptions}
                placeholder={"Country"}
                value={billingForm.country}
                onSelect={(e) => formFieldUpdate("country", e)}
                optlabel={"label"}
                optvalue={"value"}
                fontSize={true}
                disabled={isFullOrgAddress || updated}
              />
              <Dropdown
                title="State"
                key={billingForm.country}
                options={billingForm.states}
                placeholder="Select State"
                value={billingForm.state}
                onSelect={(e) => formFieldUpdate("state", e)}
                optlabel={"label"}
                optvalue={"value"}
                fontSize={true}
                error={errors.state}
                errorMessage={errorMessages.state}
                disabled={isFullOrgAddress || updated}
              />
            </Grid2>
            <CustomInput
              title="Address"
              placeholder="Enter your address"
              value={billingForm.address}
              setValue={(e) => formFieldUpdate("address", e)}
              error={errors.address}
              errorMessage={errorMessages.address}
              fontSize={true}
              disabled={isFullOrgAddress || updated}
            />
            <Grid2 className={styles.inputContainer}>
              <CustomInput
                title="City"
                placeholder="Enter your city"
                value={billingForm.city}
                setValue={(e) => {
                  if (/^[a-zA-Z\s]*$/.test(e)) {
                    formFieldUpdate("city", e);
                  }
                }}
                error={errors.city}
                errorMessage={errorMessages.city}
                fontSize={true}
                disabled={isFullOrgAddress || updated}
              />
              <CustomInput
                title="Zip Code"
                placeholder="Enter Zip Code"
                value={billingForm.zipCode}
                setValue={(e) => formFieldUpdate("zipCode", e)}
                error={errors.zipCode}
                errorMessage={errorMessages.zipCode}
                fontSize={true}
                disabled={isFullOrgAddress || updated}
              />
            </Grid2>
            {/* <Grid2 className={styles.privacyContainer}>
          {isChecked ? (
            <CheckBoxIcon
              onClick={handleCheckboxChange}
              sx={{ color: "#135fc2" }}
            />
          ) : (
            <CheckBoxOutlineBlankIcon
              onClick={handleCheckboxChange}
              sx={{ color: "#135fc2" }}
            />
          )}
          <Grid2 className={styles.label16}>Add company detils</Grid2>
        </Grid2> */}
            {/* {isChecked && (
              <Grid2 className={styles.inputContainer}>
                <CustomInput
                  title="Company Name"
                  value={billingForm.companyName}
                  setValue={(e) => formFieldUpdate("companyName", e)}
                  error={errors.companyName}
                  errorMessage={errorMessages.companyName}
                  fontSize={true}
                  disabled={isFullOrgAddress || updated}
                />
                <CustomInput
                  title="VAT/Tax Id"
                  value={billingForm.taxId}
                  setValue={(e) => formFieldUpdate("taxId", e)}
                  error={errors.taxId}
                  errorMessage={errorMessages.taxId}
                  fontSize={true}
                  disabled={isFullOrgAddress || updated}
                />
              </Grid2>
            )} */}
          </Grid2>
        ))}
    </Grid2>
  );
}
